import React from 'react'
import { Skeleton, Box } from '@mui/material';

export const CuestionarioHistoricoSkeleton = () => {
    return (
        <Box sx={{
            width: 'calc(100%)',
            textAlign: 'center'
        }}>
            <Skeleton variant='rectangular' width={1100} height={100} animation="wave" />
            <Skeleton variant='rectangular' width={1100} height={100} animation="wave" />
            <Skeleton variant='rectangular' width={1100} height={100} animation="wave" />
        </Box>
    )
}